import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { AdaptImplementationKitModule } from "@common/implementation-kit/implementation-kit.module";
import { AdaptToolbarModule } from "@common/shell/toolbar/toolbar.module";
import { AdaptCommonDialogModule } from "@common/ux/adapt-common-dialog/adapt-common-dialog.module";
import { AdaptButtonModule } from "@common/ux/button/button.module";
import { AdaptCollapsibleModule } from "@common/ux/collapsible/collapsible.module";
import { AdaptDateModule } from "@common/ux/date/date.module";
import { AdaptHtmlEditorModule } from "@common/ux/html-editor/html-editor.module";
import { AdaptLoadingSpinnerModule } from "@common/ux/loading-spinner/loading-spinner.module";
import { AdaptMenuModule } from "@common/ux/menu/menu.module";
import { AdaptStopPropagationDirective } from "@common/ux/stop-propagation.directive";
import { AdaptTooltipModule } from "@common/ux/tooltip.directive/tooltip.module";
import { AdaptTwoColumnModule } from "@common/ux/two-column/two-column.module";
import { AdaptUniversalDashboardElementModule } from "@common/ux/universal-dashboard-element/universal-dashboard-element.module";
import { DxAccordionModule, DxCheckBoxModule, DxListModule } from "devextreme-angular";
import { CollapseModule } from "ngx-bootstrap/collapse";
import { AuthorisationService } from "../authorisation/authorisation.service";
import { AdaptCallToActionModule } from "../call-to-action/call-to-action.module";
import { AdaptDirectorySharedModule } from "../directory-shared/directory-shared.module";
import { AssignIntegratedVisionDialogComponent } from "./assign-integrated-vision-dialog/assign-integrated-vision-dialog.component";
import { AssignIntegratedVisionMeetingAgendaItemComponent } from "./assign-integrated-vision-meeting-agenda-item/assign-integrated-vision-meeting-agenda-item.component";
import { CaptureVisionDialogComponent } from "./capture-vision-dialog/capture-vision-dialog.component";
import { CaptureVisionMeetingAgendaItemComponent } from "./capture-vision-meeting-agenda-item/capture-vision-meeting-agenda-item.component";
import { CategoryVisionAccordionComponent } from "./category-vision-accordion/category-vision-accordion.component";
import { DisplayVisionsByPersonComponent } from "./display-visions-by-person/display-visions-by-person.component";
import { EditIntegratedVisionPageRoute, EditPersonalVisionPageRoute, EditVisionPageComponent } from "./edit-vision-page/edit-vision-page.component";
import { TeamVisionDashboardElementComponent } from "./team-vision-dashboard-element/team-vision-dashboard-element.component";
import { VisionAuthService } from "./vision-auth.service";
import { VisionPageComponent, VisionPageRoute } from "./vision-page/vision-page.component";

@NgModule({
    declarations: [
        VisionPageComponent,
        DisplayVisionsByPersonComponent,
        CategoryVisionAccordionComponent,
        EditVisionPageComponent,
        AssignIntegratedVisionDialogComponent,
        CaptureVisionMeetingAgendaItemComponent,
        AssignIntegratedVisionMeetingAgendaItemComponent,
        TeamVisionDashboardElementComponent,
        CaptureVisionDialogComponent,
    ],
    imports: [
        CommonModule,
        RouterModule,
        DxAccordionModule,
        DxListModule,
        DxCheckBoxModule,
        CollapseModule,
        AdaptCallToActionModule,
        AdaptButtonModule,
        AdaptToolbarModule,
        AdaptLoadingSpinnerModule,
        AdaptHtmlEditorModule,
        AdaptDirectorySharedModule,
        AdaptTwoColumnModule,
        AdaptCollapsibleModule,
        AdaptTooltipModule,
        AdaptToolbarModule,
        AdaptMenuModule,
        AdaptDateModule,
        AdaptCommonDialogModule,
        AdaptUniversalDashboardElementModule,
        AdaptStopPropagationDirective,
        AdaptImplementationKitModule,
    ],
    exports: [
        TeamVisionDashboardElementComponent,
    ],
})
export class AdaptVisionModule {
    public static readonly Routes = [
        ...VisionPageRoute.routes,
        ...EditPersonalVisionPageRoute.routes,
        ...EditIntegratedVisionPageRoute.routes,
    ];

    // prevent being optimised by tree-shaker
    public readonly meetingAgendaItemComponents = [
        CaptureVisionMeetingAgendaItemComponent,
        AssignIntegratedVisionMeetingAgendaItemComponent,
    ];

    constructor(authorisationService: AuthorisationService) {
        VisionAuthService.registerAccess(authorisationService);
    }
}
